//TODO: change componentName to use card.CardComponentName
export default function getCardItemProps(card) {
    return {
        ordinal: card.CardOrdinal,
        cardTitle: card.CardTitle,
        cardTools: card.CardTools,
        cardToolsSubheader: card.CardToolsSubheader,
        cardIconKey: card.CardIconKey,
        type: card.CardType,
        retrievalUrl: card.RetrievalUrl,
        componentName: card.CardComponentName,
        staleTime: card.StaleTime,
        dashboardVariantCardRetrievalID: card.DashboardVariantCardRetrievalID,
        defaultToggleState: card.CardDefaultDisplay
    };
}